import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Commissary from "../pages/commissary/page";
import Regulations from "../pages/regulations/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/commissary",
    element: <Commissary />,
  },
  {
    path: "/regulations",
    element: <Regulations />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;